export const getNotificationsLoading = (state) => state.notifications.loading;

export const getNotifications = (state) => state.notifications.data;
